"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var underscore_1 = require("underscore");

var BaseProperty_1 = __importDefault(require("./BaseProperty"));

var RuleConstants_1 = require("../../definitions/constants/RuleConstants");

var RuleConditionOptions_1 = __importDefault(require("../../definitions/constants/RuleConditionOptions"));

var ConditionalFormatSpecHelper_1 = require("./util/ConditionalFormatSpecHelper");

var Condition =
/** @class */
function (_super) {
  __extends(Condition, _super);

  function Condition(spec, isStartCondition) {
    if (spec === void 0) {
      spec = {};
    }

    if (isStartCondition === void 0) {
      isStartCondition = true;
    }

    var _this = _super.call(this) || this;

    _this.type = spec['type'];
    _this.isStartCondition = isStartCondition;
    var value = spec['value'];

    if (typeof value === 'number') {
      _this.value = value;
    } else if (typeof value === 'string') {
      _this.value = parseInt(value, 10);
    }

    return _this;
  }

  Condition.prototype.setDefaultValue = function (scale, minValue, maxValue) {
    this.defaultValue = ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.getDefaultConditionValue(this.isStartCondition, scale, minValue, maxValue);
  };

  Condition.prototype.getType = function () {
    return this.type;
  };

  Condition.prototype.setType = function (value) {
    this.type = value;
  };

  Condition.prototype.getValue = function () {
    return this._getValue();
  };

  Condition.prototype.setValue = function (value) {
    // Only set if the value is not the same as default, otherwise set it to null
    // This case exist when the change the value the do an undo.
    // When undo the value pass in is equal to the default value
    this.value = value !== this.defaultValue ? value : undefined;
  };

  Condition.prototype.hasValue = function () {
    return underscore_1.isNumber(this.value);
  };

  Condition.prototype.toJSON = function (saveToContentModel) {
    // Do this check to ensure saveToContentModel is boolean since
    // bi/js/gemini/lib/@waca/src/core/EventEmitter.js:trigger call this toJSON passing in the event objectc which is not a boolean
    var forContentModel = underscore_1.isBoolean(saveToContentModel) ? saveToContentModel : false;
    var obj = {
      type: this.type
    };

    if (forContentModel) {
      if (underscore_1.isNumber(this.value)) {
        obj.value = this.value;
      }
    } else {
      obj.value = this._getValue();
    }

    return obj;
  };

  Condition.prototype._getValue = function () {
    return underscore_1.isNumber(this.value) ? this.value : this.defaultValue;
  };

  return Condition;
}(BaseProperty_1.default);

exports.Condition = Condition;

var Rule =
/** @class */
function (_super) {
  __extends(Rule, _super);

  function Rule(spec) {
    if (spec === void 0) {
      spec = {};
    }

    var _this = _super.call(this) || this;

    _this.ruleType = spec['ruleType'];

    if (spec['startCondition']) {
      _this.startCondition = spec['startCondition'];
    }

    if (spec['endCondition']) {
      _this.endCondition = spec['endCondition'];
    }

    _this.ruleStyle = spec['ruleStyle'];
    _this.operator = spec['operator'];
    _this.expand = spec['expand'] || false;
    return _this;
  }

  Rule.prototype.getRuleType = function () {
    return this.ruleType;
  };

  Rule.prototype.setRuleType = function (value) {
    this.ruleType = value;
  };

  Rule.prototype.getStartCondition = function () {
    return this.startCondition;
  };

  Rule.prototype.getRuleStartConditionType = function () {
    return this.startCondition.getType();
  };

  Rule.prototype.setRuleStartConditionType = function (type) {
    return this.startCondition.setType(type);
  };

  Rule.prototype.getRuleStartConditionValue = function () {
    return this.startCondition.getValue();
  };

  Rule.prototype.setRuleStartConditionValue = function (value) {
    this.startCondition.setValue(value);
  };

  Rule.prototype.getRuleEndConditionType = function () {
    return this.endCondition.getType();
  };

  Rule.prototype.setRuleEndConditionType = function (type) {
    return this.endCondition.setType(type);
  };

  Rule.prototype.getRuleEndConditionValue = function () {
    return this.endCondition.getValue();
  };

  Rule.prototype.setRuleEndConditionValue = function (value) {
    this.endCondition.setValue(value);
  };

  Rule.prototype.getRuleStyleTextColor = function () {
    return this.ruleStyle.getTextColor();
  };

  Rule.prototype.setRuleStyleTextColor = function (color) {
    this.ruleStyle.setTextColor(color);
  };

  Rule.prototype.getRuleStyleFillColor = function () {
    return this.ruleStyle.getFillColor();
  };

  Rule.prototype.setRuleStyleFillColor = function (color) {
    this.ruleStyle.setFillColor(color);
  };

  Rule.prototype.getRuleStyleShape = function () {
    return this.ruleStyle.getShape();
  };

  Rule.prototype.setRuleStyleShape = function (shape) {
    this.ruleStyle.setShape(shape);
  };

  Rule.prototype.setStartCondition = function (value) {
    this.startCondition = value;
  };

  Rule.prototype.hasEndCondition = function () {
    return !!this.endCondition;
  };

  Rule.prototype.getEndCondition = function () {
    return this.endCondition;
  };

  Rule.prototype.setEndCondition = function (value) {
    this.endCondition = value;
  };

  Rule.prototype.getRuleStyle = function () {
    return this.ruleStyle;
  };

  Rule.prototype.setRuleStyle = function (value) {
    this.ruleStyle = value;
  };

  Rule.prototype.getOperator = function () {
    return this.operator;
  };

  Rule.prototype.setOperator = function (value) {
    this.operator = value;
  };

  Rule.prototype.setRangeOperator = function (type) {
    this.operator = type;

    var isValid = this._hasValidOperator();

    if (isValid) {
      if (this.operator === RuleConstants_1.RangeOperators.and) {
        this.ruleType = RuleConstants_1.RULE_TYPES.RANGE;
        var spec = {
          type: RuleConditionOptions_1.default.getEndConditionTypeBaseOnStartCondtionType(this.startCondition.getType())
        };
        this.endCondition = new Condition(spec,
        /* isStartCondition */
        false);
      } else {
        this.ruleType = RuleConstants_1.RULE_TYPES.THRESHOLD; // remove the end condition from the rule

        delete this.endCondition;
      }
    } else {
      console.log('Unsupported rule operator: ' + this.operator);
    }

    return this.endCondition;
  };

  Rule.prototype.setExpand = function (value) {
    this.expand = value;
  };

  Rule.prototype.updateVisType = function (visType) {
    this.ruleStyle.updateVisType(visType);
  };

  Rule.prototype.toJSON = function (saveToContentModel) {
    // Do this check to ensure saveToContentModel is boolean since
    // bi/js/gemini/lib/@waca/src/core/EventEmitter.js:trigger call this toJSON passing in the event objectc which is not a boolean
    var forContentModel = underscore_1.isBoolean(saveToContentModel) ? saveToContentModel : false;

    var obj = _super.prototype.toJSON.call(this, forContentModel);

    if (forContentModel) {
      delete obj['expand'];
    }

    return obj;
  };

  Rule.prototype._hasValidOperator = function () {
    return this.operator === RuleConstants_1.RangeOperators.and || this.operator === RuleConstants_1.RangeOperators.none;
  };

  return Rule;
}(BaseProperty_1.default);

exports.Rule = Rule;

var RuleStyle =
/** @class */
function (_super) {
  __extends(RuleStyle, _super);

  function RuleStyle(spec, visType) {
    if (spec === void 0) {
      spec = {};
    }

    var _this = _super.call(this) || this;

    _this.fillColor = spec['fillColor'];
    _this.textColor = spec['textColor'];
    _this.shape = spec['shape'];

    if (ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.isKpiVis(visType)) {
      // KPI does not support fillColor
      _this._blackListedAttr.push('fillColor');
    }

    return _this;
  }

  RuleStyle.prototype.getFillColor = function () {
    return this.fillColor;
  };

  RuleStyle.prototype.setFillColor = function (value) {
    this.fillColor = value;
  };

  RuleStyle.prototype.getTextColor = function () {
    return this.textColor;
  };

  RuleStyle.prototype.setTextColor = function (value) {
    this.textColor = value;
  };

  RuleStyle.prototype.getShape = function () {
    return this.shape;
  };

  RuleStyle.prototype.setShape = function (value) {
    this.shape = value;
  };

  RuleStyle.prototype.updateVisType = function (visType) {
    ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.updateBlackListedAttrBaseOnVisType(visType, 'fillColor', this._blackListedAttr);
  };

  return RuleStyle;
}(BaseProperty_1.default);

exports.RuleStyle = RuleStyle;
